(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowDiagram', drvWorkflowDiagram);

    drvWorkflowDiagram.$inject = ['$timeout'];
    
    function drvWorkflowDiagram($timeout) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                selectedStep: '=',
                api: '='
            },
            controller: controller
        };

        var paper;
        var selectedCell;

        return directive;

        function controller($scope, $element, DialogService, WorkflowStepTypesService) {

            /**
             * Add a workflow step.
             */
            $scope.api.addStep = function (stepType) {
                var stepDefinition = WorkflowStepTypesService.getStepType(stepType);

                if (angular.isUndefined(stepDefinition)) {
                    DialogService.alert('Could not find definition for step type: ' + stepType);
                } else {
                    var newShape = createGraphShape(stepDefinition);

                    newShape.prop('Step', {
                        StepId: newShape.id,
                        StepType: stepType,
                        Properties: angular.copy(stepDefinition.properties),
                        Name: stepDefinition.text
                    });

                    $scope.graph.addCell(newShape);
                }
            };

            /**
             * Add a link. Link starts out not joined to anything and user must connect it.
             */
            $scope.api.addLink = function () {
                var link = new joint.dia.Link({});
                link.attr({
                    '.marker-target': { fill: 'yellow', d: 'M 10 0 L 0 5 L 10 10 z' }
                });
                link.set('source', { x: 10, y: 40 });
                link.set('target', { x: 150, y: 40 });
                $scope.graph.addCells([link]);
            };

            /**
             * Delete the selected workflow step, link, etc.
             */
            $scope.api.deleteSelectedStep = function () {
                if (angular.isDefined(selectedCell) && selectedCell !== null) {
                    var cellId = selectedCell.id;

                    selectedCell.remove({ disconnectLinks: false });
                    selectedCell = null;

                    _.remove($scope.steps, function (n) {
                        return n.StepId === cellId;
                    });

                    $scope.selectedStep = null;
                }
            };

            /**
             * Set the steps and graph/diagram.
             */
            $scope.api.setStepsAndGraphData = function (steps) {
                angular.forEach(steps, function (step) {
                    if (step.StepId === '') {
                        step.StepId = joint.util.uuid();
                    }
                });

                angular.forEach(steps, function (step) {
                    if (step.StepType !== 'Link') {
                        var stepDefinition = WorkflowStepTypesService.getStepType(step.StepType);

                        if (angular.isUndefined(stepDefinition) || stepDefinition === null) {
                            stepDefinition = {
                                type: step.StepType,
                                drawingProperties: {
                                    color: 'red'
                                },
                                text: '!! Unrecognised Step Type !!',
                                properties: {
                                }
                            };
                        }

                        var newShape = createGraphShape(stepDefinition, step.StepId);
                        newShape.attributes.position.x = step.Drawing.X;
                        newShape.attributes.position.y = step.Drawing.Y;
                        newShape.prop('Step', {
                            StepId: step.StepId,
                            StepType: step.StepType,
                            Properties: angular.copy(step.Properties),
                            Name: step.Name
                        });
                        setShapeText(newShape, step.Name);

                        $scope.graph.addCell(newShape);
                    }
                });

                // Links must be added after steps to be sure JointJS draws them correctly.
                angular.forEach(steps, function (step) {
                    if (step.StepType === 'Link') {
                        var link = new joint.dia.Link({
                            source: {
                                id: step.Properties.Source,
                                port: step.Properties.SourcePort
                            },
                            target: {
                                id: step.Properties.Target,
                                port: step.Properties.TargetPort
                            },
                            id: step.StepId
                        });
                        link.attr({
                            '.marker-target': { fill: 'yellow', d: 'M 10 0 L 0 5 L 10 10 z' }
                        });

                        if (angular.isDefined(step.Drawing) && step.Drawing !== null && angular.isDefined(step.Drawing.Vertices) && step.Drawing.Vertices.length) {
                            link.attributes.vertices = [];
                            angular.forEach(step.Drawing.Vertices, function (vertex) {
                                link.attributes.vertices.push({
                                    x: vertex.X,
                                    y: vertex.Y
                                });
                            });
                        }

                        $scope.graph.addCell(link);
                    }
                });
            };

            /**
             * Get the workflow steps.
             */
            $scope.api.getSteps = function () {
                var steps = [];

                angular.forEach($scope.graph.getCells(), function (cell) {
                    var stepDefinition;

                    if (cell.attributes.type === 'link') {
                        stepDefinition = {
                            StepId: cell.id,
                            StepType: 'Link',
                            Properties: {
                                Source: cell.attributes.source.id,
                                Target: cell.attributes.target.id,
                                SourcePort: cell.attributes.source.port,
                                TargetPort: cell.attributes.target.port
                            }
                        };

                        if (angular.isDefined(cell.attributes.vertices) && cell.attributes.vertices.length) {
                            stepDefinition.Drawing = { Vertices: [] };
                            angular.forEach(cell.attributes.vertices, function (vertex) {
                                stepDefinition.Drawing.Vertices.push({
                                    X: vertex.x,
                                    Y: vertex.y
                                });
                            });
                        }
                    } else {
                        stepDefinition = angular.copy(cell.prop('Step'));
                        stepDefinition.StepId = cell.id;
                        stepDefinition.Drawing = {
                            X: cell.attributes.position.x,
                            Y: cell.attributes.position.y
                        };
                    }

                    steps.push(stepDefinition);
                });

                return steps;
            };
        }

        function link(scope, element, attrs) {
            scope.graph = new joint.dia.Graph();

            scope.$watch('selectedStep.Name', function (newVal, oldVal) {
                if (angular.isDefined(selectedCell) && selectedCell !== null) {
                    setShapeText(selectedCell, newVal);
                }
            });

            paper = new joint.dia.Paper({
                el: element,
                width: 1000,
                height: 800,
                gridSize: 1,
                model: scope.graph
            });

            paper.on('blank:pointerdown', function () {
                if (angular.isDefined(selectedCell) && selectedCell !== null) {
                    selectedCell.attributes.attrs.rect['stroke-width'] = 1;
                    selectedCell = null;
                    scope.graph.resetCells(scope.graph.getCells());
                    scope.$apply(function () {
                        scope.selectedStep = null;
                    });
                }
            });

            paper.on('cell:pointerdown', function (cellView, evt, x, y) {
                var cell = scope.graph.getCell(cellView.model.id);
                
                if (cell.attributes.type === 'basic.Rect' || cell.attributes.type === 'devs.Model') {
                    if (angular.isDefined(selectedCell) && selectedCell !== null) {
                        selectedCell.attributes.attrs.rect['stroke-width'] = 1;
                    }
                    selectedCell = cell;

                    var stepText = cell.attributes.attrs.text.text;

                    scope.$apply(function () {
                        scope.selectedStep = cell.prop('Step');
                    });

                    cell.attributes.attrs.rect['stroke-width'] = 5;
                    scope.graph.resetCells(scope.graph.getCells());
                }
            });
        }

        /**
         * Set the text on a JointJS shape.
         */
        function setShapeText(shape, text) {
            if (angular.isUndefined(text) || text === null) {
                shape.attr('text/text', '');
            } else {
                shape.attr('text/text', joint.util.breakText(text, shape.attributes.size, shape.attributes.attrs.text));
            }
        }

        /**
         * Create a JointJS graph shape from the given step definition.
         */
        function createGraphShape(stepDefinition, id) {
            var newShape;
            switch (stepDefinition.drawingProperties.type) {
                case 'sentinel':
                    newShape = new joint.shapes.basic.Circle({
                        position: { x: 0, y: 0 },
                        size: { width: 50, height: 50 },
                        attrs: {
                            circle: { fill: stepDefinition.drawingProperties.color },
                            text: { fill: 'white' }
                        },
                        id: id
                    });
                    break;
                case 'merge':
                    newShape = new joint.shapes.basic.Rect({
                        position: { x: 0, y: 0 },
                        size: { width: 60, height: 80 },
                        attrs: {
                            rect: { fill: stepDefinition.drawingProperties.color, 'stroke-width': 1 },
                            text: { fill: 'white' }
                        },
                        id: id
                    });
                    break;
                case 'question':
                    newShape = new joint.shapes.basic.Rect({
                        position: { x: 0, y: 0 },
                        size: { width: 100, height: 50 },
                        attrs: {
                            rect: { fill: stepDefinition.drawingProperties.color, rx: 20, ry: 20, 'stroke-width': 1 },
                            text: { fill: 'white' }
                        },
                        id: id
                    });
                    break;
                case 'branch':
                    newShape = new joint.shapes.devs.Model({
                        position: { x: 0, y: 0 },
                        size: { width: 100, height: 60 },
                        inPorts: ['in'],
                        outPorts: ['true', 'false'],
                        attrs: {
                            rect: { fill: stepDefinition.drawingProperties.color, rx: 10, ry: 10, 'stroke-width': 1 },
                            text: { fill: 'white', 'font-size': 14 },
                        },
                        ports: {
                            groups: {
                                'in': {
                                    attrs: {
                                        '.port-body': {
                                            fill: '#ffd268'
                                        }
                                    }
                                },
                                'out': {
                                    attrs: {
                                        '.port-body': {
                                            fill: '#ffbb1c'
                                        }
                                    }
                                }
                            }
                        },
                        id: id
                    });
                    break;
                default:
                    newShape = new joint.shapes.basic.Rect({
                        position: { x: 0, y: 0 },
                        size: { width: 100, height: 40 },
                        attrs: {
                            rect: { fill: stepDefinition.drawingProperties.color, 'stroke-width': 1 },
                            text: { fill: 'white' }
                        },
                        id: id
                    });
            }

            setShapeText(newShape, stepDefinition.text);

            return newShape;
        }
    }
})();